<template>
    <v-btn v-if="!isGuest"
           ref="download-lut-button"
		   :disabled="isDisabled"
           @click="onClick"
           v-tippy="{placement: 'left'}"
           content="Download a LUT"
           name="download-lut-button"
           v-bind="exportLUTBindings"
    >
        <v-icon class="material-symbols-outlined">deployed_code_update</v-icon>
<!--        <tippy-->
<!--            v-if="startTips == 5"-->
<!--            theme="&#45;&#45;start"-->
<!--            showOnInit="true"-->
<!--            :onHide="() => { if (startTips == 5) return false }"-->
<!--            to="download-lut-button"-->
<!--        >-->
<!--            <span class="step">5 of 5</span>-->
<!--            <span class="title">Export your work</span>-->
<!--            <span class="description">Once you are happy with the result, you can export your look as a LUT that can be used in a wide variety of software or save a graded image</span>-->
<!--        </tippy>-->
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
        isDisabled() {
            return !this.canExportLUT || !this.image || this.IDT.initial || this.blockLoading;
        }
    },
    mounted() {
        this.$root.$refs.downloadLUTButton = this.$refs['download-lut-button'];
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;
        	// if (this.startTips == 5) this.$store.dispatch('UI/setStartTips', 'completed');

            // if (lutify.isCurrentPlanFree()) {
            //     UI.showModal(UI.modals.notAvailableInFree.el);
            //     return;
            // }

            this.$store.dispatch('UI/setRightColumn', 'download-lut')
        }
	}
}
</script>